module.exports = __webpack_public_path__ + "img/button-more.b75ca846.png";